module.exports = __webpack_public_path__ + "static/img/title_03@2x.ace121b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/title_03@2x.png
// module id = Y3YB
// module chunks = 1